<template>
  <value-container v-if="view_only" :value="get_names()" :label="no_label?null:label||'Áreas Impactadas'" :md="md"/>
	<component v-else :is='c_tag' :md3="md==3" :md4="md==4" :md5="md==5" :md8="md==8">
    <fs1-div style="font-weight: bolder" v-if="!no_label">
      {{label||'Áreas Impactadas'}}
      <fs1-tooltip text="Corresponden a aquellas áreas impactadas productivamente en caso de que el activo sufra algún desperfecto. Existen ocasiones donde algunos activos afectan más de un área"/>
    </fs1-div>
    <v-select
      :placeholder="value && value.length ? undefined : ' seleccionar'"
      v-model="model"
      :items="filter?filteredItems:items"
      :item-text="(r) => get_name(r)"
      item-value="id"
      :multiple="!single"
      :disabled="disabled"
      :small-chips="chips"
      :chips="chips"
      :deletable-chips="chips"
			:prepend-icon="p_icon"
      :class="(!single?!value.length:!value) && 'textEmpty'"/>
      <template v-if="old_value != undefined">
        <value-container v-for="(v,i) in old_value_removed_names" :key="`r-${i}`" :value="v" class_name="output_old_value_removed"/>
        <value-container v-for="(v,i) in old_value_added_names" :key="`a-${i}`" :value="v" class_name="output_old_value_added"/>
      </template>

	</component>
</template>

<script>
import in_select from '../mixins/inputs/select.js';
export default {
  props:['no_label','p_icon','single','abr'],
  mixins:[in_select],
  computed: {
    items(){ return this.$store.getters.listImpactedAreas },
  },
  methods:{
    get_name(r){ return this.abr?r.name:`${r.name} - ${r.full_name}` },
    get_names(){
      return (this.filter?this.filteredItems:this.items)
        .filter(i=>Array.isArray(this.model)?this.model.includes(i.id):this.model===i.id)
        .map(i=>this.get_name(i))
    }
  }
};
</script>
